export default "__VITE_ASSET__NXSNebEe__"